import Vue from 'vue'
import Vuex from 'vuex'
import order from './modules/order'
import catalog from './modules/catalog'
import user from './modules/user'
import app from './modules/app'
import basket from './modules/basket'
import combo from './modules/combo'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        app,
        order,
        catalog,
        user,
        basket,
        combo
    },
    strict: debug,
})
